// Vite env reader kept in its own module so unit tests can mock it: import.meta.env
// isn't reachable via vi.stubEnv across module boundaries in this Vitest setup.
export const getEnv = (key: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (import.meta as any).env?.[key];
};

// ============ Environment Variables ============
export const isProduction = getEnv("VITE_ENV") === "production";
export const cognitoRegion = getEnv("VITE_COGNITO_REGION");
